import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { useInstallationContext } from '../../context/installation';
import { useApplicationStore } from '../../store/application';
import { useBottomNavigation } from './hooks/use-bottom-navigation';
import './index.scss';

export const Navigation: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { selectedInstallation } = useInstallationContext();
  const { links } = useBottomNavigation();
  const bottomNavigationHidden = useApplicationStore((s) => s.bottomNavigationHidden);

  const styles = {
    '--preference-color': selectedInstallation?.hexColor,
  } as React.CSSProperties;

  if (bottomNavigationHidden) return null;

  return (
    <nav className="navigation">
      <ul className="navigation__list">
        {links.map((link) => (
          <li key={link.title} className="navigation__list-item">
            <button
              style={styles}
              onClick={() => navigate(link.href)}
              className={classNames('', {
                'navigation__list-item--active': pathname === link.href,
                'navigation__list-item--preference': link.preference,
              })}
            >
              <link.Icon />
              {link.title && <p className="nav_title">{link.title}</p>}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};
